/** Shown on EVERY screen that displays balances, orders or transfers.
 * WnF Exchange is a simulated spot exchange: all money on it is test funds. */
export function TestFundsBanner() {
  return (
    <div className="wnf-banner" role="note" data-testid="test-funds-banner">
      <strong>TEST FUNDS — no real money.</strong> WnF Exchange is a simulated exchange: balances, deposits, withdrawals
      and orders here are practice values only and can never be paid out.
    </div>
  )
}
